export const sidebarwith = 350


